module.exports = {"title":"Search Results TODO","hideTransactionInfo":"Hide transaction info"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Search/SearchResults/locales/fr.json
// module id = 1415
// module chunks = 0